import { initDependencies, setupDependencies } from '../app';
import { createContext } from './services/createContext';
import { runApp } from './services/runApp';

setupDependencies();

const rawApplicationContext = initDependencies();
const applicationContext = createContext(rawApplicationContext);

runApp(applicationContext);

// oxlint-disable-next-line typescript/no-explicit-any
if ((module as any).hot) {
  // oxlint-disable-next-line typescript/no-explicit-any
  (module as any).hot.accept();
}
